import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './breadcrumb-menu.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';

const renderBreadCrumb = (item) => {
    let breadcrumb;
    if (item.relativeUrl) {
        breadcrumb = x `<a class="breadcrumb-link" href="${item.relativeUrl}">${o(item.pageName)}</a>`;
    }
    else {
        breadcrumb = x `<span class="breadcrumb-text">${o(item.pageName)}</span>`;
    }
    return x `<li class="item">${breadcrumb}</li>`;
};
class BreadcrumbMenu extends s {
    render() {
        const breadcrumbs = x `${this.breadcrumbs.map(item => renderBreadCrumb(item))}`;
        return x `<ul class="breadcrumb-menu ${this.rtl || isRTL() ? 'rtl' : ''}">${breadcrumbs}</ul>`;
    }
}
BreadcrumbMenu.styles = css_248z;
__decorate([
    n({ type: Array })
], BreadcrumbMenu.prototype, "breadcrumbs", void 0);
__decorate([
    n({ type: Boolean })
], BreadcrumbMenu.prototype, "rtl", void 0);
customElements.define('breadcrumb-menu', BreadcrumbMenu);

export { BreadcrumbMenu };
